import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { StoryChapterThumbnail } from 'src/app/story/models/story-chapter-thumbnail.model';
import { ChapterModel } from 'src/app/story/models/chapter.model';

@Component({
  selector: 'app-view-chapters-list-item',
  templateUrl: './view-chapters-list-item.component.html',
  styleUrls: ['./view-chapters-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewChaptersListItemComponent implements OnInit {
  @Input()
  thumbnail: StoryChapterThumbnail;

  @Input()
  chapter: ChapterModel;

  @Input()
  index: number;

  @Input()
  selected: boolean;


  constructor() { }

  ngOnInit() {
  }

  // return css block for image
  getChapterThumb(chapterId): any {
    // use snapshot if present, otherwise use small
    if (!!this.thumbnail) {
      const url = (this.thumbnail.snapshot) ? this.thumbnail.snapshot : this.thumbnail.urls.small;

      return {
        'background-image': `url(${url})`,
        'background-size': 'cover'
      };
    } else {
      return {};
    }
  }

}
